import { enumKeysToArray } from '@/utils/enum'
import { makeServicesTypes } from '@/core/container/makeServicesTypes'

export enum NOTE_SERVICES {
  NoteCreateFormService,
  NoteEditFormService,
  NoteEditFormServiceFactory,
}

export type NoteServices = keyof typeof NOTE_SERVICES

export const NOTE_SERVICE_TYPES: Record<NoteServices, symbol> = makeServicesTypes<NoteServices>(
  enumKeysToArray<NoteServices>(NOTE_SERVICES),
)
